import { termBadgeTemplate } from "../templates";

var TermBadge = Backbone.View.extend({
    tagName: 'span',
    className: 'term-badge',
    events: {
        'click' : 'unselectTerm'
    },
    initialize: function(){
        _.bindAll( this, 'render', 'unselectTerm' );
        this.render();
    },
    /*
    Render the view markup
    */
    render: function(){
        var details = this.model.toJSON();
        var itemHtml = termBadgeTemplate( details );
        this.el.innerHTML = itemHtml;
    },
    /*
    Clear out this selection from the filter.
    Trigger removing event and also cleanup the model and remove the view
    */
    unselectTerm : function( e ){
        e.preventDefault();
        this.model.trigger( 'removing', this.model );
        this.model.destroy();
        this.remove();
    }
    
});



export {TermBadge};